
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claude-api-ui-free",
      function () {
        return require("private-next-pages/claude-api-ui-free.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claude-api-ui-free"])
      });
    }
  